import AnswerItem from "@/components/pages/CartoonDetailPage/BonusQuestionSection/AnswerItem"
import useBonusQuestion from "@/components/pages/CartoonDetailPage/BonusQuestionSection/BonusQuestion/useBonusQuestion"
import Badge from "@/components/shared/Badge"
import Button from "@/components/shared/Button"
import Typography from "@/components/shared/Typography"
import Image from "next/image"
import { useTranslation } from "react-i18next"
import { AnswerType, GetPlayerBonusQuestionResult } from "swagger/models"
import { twMerge } from "tailwind-merge"

interface BonusQuestionProps {
  data: GetPlayerBonusQuestionResult
}

const BonusQuestion = ({ data }: BonusQuestionProps) => {
  const { coins, handleCheckAnswers, handleSelectAnswer, questionType, selectedAnswers, answerState } =
    useBonusQuestion({ data })
  const { t } = useTranslation("common")

  const multipleAnswers = data.answers.filter((i) => i.isCorrect === true).length > 1

  return (
    <div className="w-full">
      {!data.claimed && (
        <div className="flex justify-center">
          <div className="flex items-center font-pally text-[24px] font-bold text-gold">
            <Image className="mr-4" src="/assets/images/grosak2.svg" width={32} height={32} alt="" />
            {coins}
          </div>
        </div>
      )}
      <div className="mt-8 flex h-4/5 flex-col justify-end rounded-[32px] bg-primary bg-opacity-8 px-[80px] py-10">
        <div className="no-scrollbar max-h-full overflow-y-auto">
          <Typography type="h4" className="text-primary-700">
            {data.text}
          </Typography>

          <Badge variant={multipleAnswers ? "questionMultiple" : "bonusQuestion"} className="my-6">
            {t(multipleAnswers ? "bonusQuestion.moreVariants" : "bonusQuestion.singleVariant")}
          </Badge>

          <div className={twMerge("grid gap-2", questionType === AnswerType.IMAGE && "grid-cols-2")}>
            {data.answers.map((i, index) => {
              const { answerId, type, fileUrl, text } = i
              return (
                <AnswerItem
                  isSelected={selectedAnswers.includes(answerId)}
                  type={type}
                  index={index}
                  key={answerId}
                  text={text || ""}
                  answerState={answerState}
                  onClick={() => {
                    if (answerState !== "") {
                      return
                    } else {
                      handleSelectAnswer(answerId)
                    }
                  }}
                  imageSrc={fileUrl || ""}
                />
              )
            })}
          </div>
        </div>
        <Button className="mt-12" onClick={handleCheckAnswers} color="primary">
          {answerState === "failure" ? t("bonusQuestion.tryAgain") : t("confirm")}
        </Button>
      </div>
    </div>
  )
}

export default BonusQuestion
